import { MutationTree } from "vuex";
import { EvalSourceMapDevToolPlugin } from "webpack";
import { CLIENTES } from "./types";

type ClientesMutationTree = MutationTree<CLIENTES>;

export const mutations: ClientesMutationTree = {};
